function Default(url) {
    this._url = url;
    this._headerBtn = $('[ data-default="btn"]');
    this._form = $('[ data-default="form"]');
    this._formBtn = $('[ data-default="form-btn"]');
    this._body = $('html, body');
}
Default.prototype._bindEvents = function () {
    const instance = this;

    this._headerBtn.on('click', function (event) {
        event.preventDefault();

        instance._scrollToForm();
    });
    this._form.on('submit', function (event) {
        event.preventDefault();
        instance._formBtn.prop('disabled', true);

        $.post({
            url: instance._url,
            data: instance._form.serialize(),
            async: true,
            success: function (response) {
                var res = jQuery.parseJSON(response);
                instance._form.find('.request-form__alerts').hide();
                instance._form.find('.request-form__input').removeClass('--error');
                if(res.error !== false) {
                    instance._form.find('.request-form__input[name="' + res.error + '"]').addClass('--error');
                } else if(res.success === true) {
                    ym(54157753, 'reachGoal', 'request_demo');
                    instance._form.find('.request-form__input').val('');
                    instance._form.find('.request-form__alerts.--success').show();
                } else {
                    instance._form.find('.request-form__alerts.--error').show();
                }
                instance._formBtn.prop('disabled', false);
            },
            error: function (response) {
                instance._form.find('.request-form__alerts').hide();
                instance._form.find('.request-form__alerts.--error').show();
                instance._formBtn.prop('disabled', false);
            }
        })
    });
}
Default.prototype._scrollToForm = function () {
    const form_offset = this._form.offset().top;

    this._body.stop().animate({ scrollTop: form_offset }, 600);
}
Default.prototype.apply = function () {
    this._bindEvents();
}